import { Component, Input } from '@angular/core';
import { AdminService } from '../../admin.service';

@Component({
  selector: 'app-schema-show',
  template: require('./schema-show.component.html'),
  styles: [require('./schema-show.component.scss')],
})
export class SchemaShowComponent {
  @Input() object: any;
  @Input() schema: any;

  constructor(
    public adminService: AdminService,
  ) { }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/admin/shared/schema-show/schema-show.component.ts